// Base URL of the Lovable (InsureHub) app rendered inside the iframe.
export const DEFAULT_INSUREHUB_URL = (
  import.meta.env.VITE_APP_INSUREHUB_URL || "https://connect-sales-stage.lovable.app"
).trim();

export const ROUTE_LABELS: Record<string, string> = {
  insurehub: "Commission Dashboard",
  ledger: "Commission Ledger",
  invoices: "Invoices",
  reconciliation: "Reconciliation Workspace",
  variances: "Variances & Disputes",
  tds: "TDS",
  reports: "Reports",
  irdai: "IRDAI Compliance",
  config: "Configuration",
  cases: "Cases",
  claims: "Claims",
};

export const getRouteLabel = (pathname: string) => {
  const segment = pathname.split("/").filter(Boolean)[0] ?? "";
  if (ROUTE_LABELS[segment]) return ROUTE_LABELS[segment];
  if (!segment) return "";
  return segment.charAt(0).toUpperCase() + segment.slice(1);
};

// Broker Operations pages live under /insurehub/* in the Lovable app, unlike the
// CRM pages (cases, claims) and the dashboard (/insurehub) which sit at the root.
// Only the embed-aware layout under this prefix honours ?embed=1 to hide the sidebar.
const INSUREHUB_PREFIXED_SEGMENTS = new Set([
  "ledger",
  "invoices",
  "reconciliation",
  "variances",
  "tds",
  "reports",
  "irdai",
  "config",
]);

const withLovablePrefix = (pathname: string) => {
  const segment = pathname.split("/").filter(Boolean)[0] ?? "";
  return INSUREHUB_PREFIXED_SEGMENTS.has(segment) ? `/insurehub${pathname}` : pathname;
};

export const buildIframeSrc = (pathname: string, search: string, baseUrl?: string) => {
  const base = (baseUrl || DEFAULT_INSUREHUB_URL).replace(/\/+$/, "");
  const path = withLovablePrefix(pathname);
  const separator = search ? "&" : "?";
  return `${base}${path}${search}${separator}embed=1`;
};
